module.exports = __webpack_public_path__ + "static/media/it.41b03921.svg";